import { focusAtom } from 'jotai-optics';
import { surveyAtom } from './surveyAtom';

export const surveyIdAtom = focusAtom(surveyAtom, (optic) =>
  optic.optional().prop('id')
);
